export function getPaisEntorno(ambitoId) {
  switch (ambitoId) {
    case 1:
      return "ES";
    case 2:
      return "PT";
    case 3:
      return "AD";
    case 4:
      return "CO";
    case 5:
      return "SN";
    case 6:
      return "MX";
    case 8:
      return "CL";
    case 9:
      return "BQ";
    default:
      return "ES";
  }
}
